import * as React from 'react';
import { useQuery } from '@apollo/client';
import * as ShowOrganization from '../../core/gql/queries/show-organizations';
import { useHistory, matchPath } from 'react-router';
import { ROUTES } from 'core/routes';

export interface Props {
  organizationId: number;
}

const DisabledOrgGuard = ({ organizationId }) => {
  const queryOrganization = useQuery(ShowOrganization.BASIC_ORG_QUERY, {
    variables: { organizationId: organizationId },
  });
  const history = useHistory();

  const isDisabledPage = !!matchPath(window.location.pathname, ROUTES.DISABLED_ORG);

  React.useEffect(() => {
    if (
      !isDisabledPage &&
      queryOrganization?.data?.showOrganization &&
      queryOrganization?.data?.showOrganization?.disabled === true
    ) {
      history.push({
        pathname: `/disabled/${organizationId}`,
        state: { source: history.location },
      });
    }
  }, [queryOrganization, history, organizationId, isDisabledPage]);

  return null;
};

export default DisabledOrgGuard;
